import { cleanCep, formatCep, type AddressValue } from '@loot/shared';
import { useTranslation } from 'react-i18next';
import { Button, Field, Input } from '../ui.tsx';
import { useCepLookup } from './useCepLookup.ts';

/**
 * CEP com a busca do endereço: procura sozinho ao completar o número, ou pelo botão. Quem usa decide
 * em que campos grava o que veio. Se a consulta falhar, o endereço continua sendo digitado.
 */
export function CepField({
  id,
  value,
  onChange,
  onFound,
}: {
  id?: string;
  value: string;
  onChange: (cep: string) => void;
  onFound: (found: Partial<AddressValue>) => void;
}) {
  const { t } = useTranslation();
  const cep = useCepLookup();
  return (
    <Field label={t('forms.address.cep')}>
      <div className="flex gap-2">
        <Input
          id={id}
          maxLength={9}
          value={value}
          onChange={(e) => {
            const raw = e.target.value;
            onChange(formatCep(raw));
            const clean = cleanCep(raw);
            if (clean && clean !== cleanCep(value)) cep.lookup(clean, onFound);
          }}
        />
        <Button
          type="button"
          variant="secondary"
          className="whitespace-nowrap"
          disabled={!cleanCep(value) || cep.pending}
          onClick={() => cep.lookup(cleanCep(value)!, onFound)}
        >
          {t('forms.address.search')}
        </Button>
      </div>
      {(cep.pending || cep.error) && (
        <p role="status" className={`text-xs ${cep.error ? 'text-danger' : 'text-muted'}`}>
          {cep.error ?? t('forms.address.searching')}
        </p>
      )}
    </Field>
  );
}
